import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { ChoiceType, SchemaItemType } from "@@/Schema";
export var Templates;
(function (Templates) {
    Templates["BusinessPlan"] = "Business Plan";
    Templates["CRM"] = "CRM";
    Templates["EmployeePerformance"] = "Employee Performance";
    Templates["ExpenseReport"] = "Expense Report";
    Templates["ImplemetationPlan"] = "Implementation Plan";
    Templates["InventoryManagement"] = "Inventory Management";
    Templates["MarketingPlan"] = "Marketing Plan";
    Templates["PayRoll"] = "Payroll";
    Templates["ProductionSchedule"] = "Production Schedule";
    Templates["ProjectBudget"] = "Project Budget";
    Templates["ProjectTimeline"] = "Project Timeline";
    Templates["PurchaseOrder"] = "Purchase Order List";
    Templates["RiskRegister"] = "Risk Regitser";
    Templates["ToDoList"] = "To-Do List";
    Templates["WorkOrder"] = "Work Order";
})(Templates || (Templates = {}));
export var DatasheetTemplate;
(function (DatasheetTemplate) {
    DatasheetTemplate["Blank"] = "Blank";
    DatasheetTemplate["CRM"] = "CRM";
    DatasheetTemplate["EmployeeManagement"] = "Employee Management";
    DatasheetTemplate["InventoryManagement"] = "Inventory Management";
    DatasheetTemplate["ProductionManagment"] = "Manufacturing Production Management";
})(DatasheetTemplate || (DatasheetTemplate = {}));
class Store {
    getFieldsForTemplate(template) {
        if (template === Templates.ProjectTimeline) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID(),
                name: 'At Risk',
                orderindex: .01,
                required: false,
                type: SchemaItemType.Boolean
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Task Name',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Sub Task Name',
                orderindex: .03,
                required: false,
                type: SchemaItemType.FormInput
            });
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Status',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Not Started',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'In Progress',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Completed',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'On Hold',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            const stask = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Assigned To',
                orderindex: .05,
                required: false,
                type: SchemaItemType.UserChoice,
                addtotasks: true,
                multiselect: false,
            };
            sitems.push(stask);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Start Date',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'End Date',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Date
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .08,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            return sitems;
        }
        if (template === Templates.BusinessPlan) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Task Name',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Phase',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Phase 1',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Phase 2',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Phase 3',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Phase 4',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Start Date',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'End Date',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Date
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .08,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            return sitems;
        }
        if (template === Templates.CRM) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Company Name',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Contact Name',
                orderindex: .03,
                required: false,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Contact Position',
                orderindex: .04,
                required: false,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Web Link',
                orderindex: .05,
                required: false,
                type: SchemaItemType.URL
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Date of Last Contact',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Date
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Next Action',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Stage of Lead',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Lead',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Marketing qualified lead',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Sales qualified lead',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Opportunity',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Customer',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Evangelist',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Other',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Source of Lead',
                orderindex: .08,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Social Media',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Email Marketing',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Paid Ads',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Referrals',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Events',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'SEO',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Other',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            const cc1text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Contact Details',
                orderindex: .091,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cc1text);
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .091,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            return sitems;
        }
        if (template === Templates.EmployeePerformance) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Quality',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Characterstics',
                orderindex: .02,
                required: true,
                type: SchemaItemType.Choice,
                items: [
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Unsatisfactory',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Satisfactory',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Good',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Excellent',
                        type: ChoiceType.Text
                    }
                ],
                multiselect: false
            };
            sitems.push(citem);
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            return sitems;
        }
        if (template === Templates.ExpenseReport) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Date',
                orderindex: .01,
                required: true,
                type: SchemaItemType.Date
            });
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Description',
                orderindex: .02,
                required: true,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Expense',
                orderindex: .03,
                required: true,
                type: SchemaItemType.Number,
            });
            const ccwtext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ccwtext);
            return sitems;
        }
        if (template === Templates.ImplemetationPlan) {
            const sitems = [];
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Priority',
                orderindex: .001,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'High',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Medium',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Low',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Task Name',
                orderindex: .002,
                required: true,
                type: SchemaItemType.FormInput
            });
            const stask = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Assigned To',
                orderindex: .003,
                required: false,
                type: SchemaItemType.UserChoice,
                addtotasks: true,
                multiselect: false,
            };
            sitems.push(stask);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Status (%)',
                orderindex: .004,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Planned Start Date',
                orderindex: .005,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Actual Start Date',
                orderindex: .006,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Planned End Date',
                orderindex: .007,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Actual End Date',
                orderindex: .008,
                required: false,
                type: SchemaItemType.Date
            });
            const cs1item = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Task Status',
                orderindex: .009,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Ahead',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'On Schedule',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Behind',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(cs1item);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Department',
                orderindex: .0091,
                required: false,
                type: SchemaItemType.FormInput
            });
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .0092,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            return sitems;
        }
        if (template === Templates.InventoryManagement) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Inventory ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Name',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Description',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Unit Price (Rs.)',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Quantity In Stock',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Inventory Price (Rs.)',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Number,
            });
            const cs1item = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Reorder',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Yes',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'No',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(cs1item);
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Reorder Urgency',
                orderindex: .001,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'High',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Medium',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Low',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Reorder Quantity',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Number,
            });
            const ccwext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .007,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ccwext);
            return sitems;
        }
        if (template === Templates.MarketingPlan) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Campaign Name',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Description',
                orderindex: .02,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Clicks',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Projected Cost',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Actual Cost',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Start Date',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'End Date',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Date
            });
            const ccwext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .08,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ccwext);
            return sitems;
        }
        if (template === Templates.PayRoll) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Employee ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Employee Name',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            const cc1text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Employee Address',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cc1text);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Position',
                orderindex: .04,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Hire Date',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Salary (Rs.)',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Pension Contribution (% of Salary)',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Number
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Overtime Rate (Rs.)',
                orderindex: .08,
                required: false,
                type: SchemaItemType.Number
            });
            const ccwext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .09,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ccwext);
            return sitems;
        }
        if (template === Templates.ProductionSchedule) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Order ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Purchase Number',
                orderindex: .012,
                required: true,
                type: SchemaItemType.FormInput
            });
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Order Status',
                orderindex: .02,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Started',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'In Progress',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Done',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Customer Name',
                orderindex: .03,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Product List',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Variation',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Total Product Quantity',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Starting Inventory',
                orderindex: .07,
                required: true,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Ending Inventory',
                orderindex: .08,
                required: true,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Start Date',
                orderindex: .09,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'End Date',
                orderindex: .091,
                required: false,
                type: SchemaItemType.Date
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Notes',
                orderindex: .092,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            return sitems;
        }
        if (template === Templates.ProjectBudget) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Project Task',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            const stask = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Assigned To',
                orderindex: .03,
                required: false,
                type: SchemaItemType.UserChoice,
                addtotasks: true,
                multiselect: false,
            };
            sitems.push(stask);
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Status',
                orderindex: .031,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Not Started',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'In Progress',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Completed',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'On Hold',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Planned Hours',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Actual Hours',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Projected Cost',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Actual Cost',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Number,
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Notes',
                orderindex: .08,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            return sitems;
        }
        if (template === Templates.PurchaseOrder) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Item ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Description',
                orderindex: .02,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Quantity',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Unit Price (Rs.)',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Total Price (Rs.)',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Number,
            });
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Status',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Not Started',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'In Progress',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Completed',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'On Hold',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            const c1text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Notes',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(c1text);
            return sitems;
        }
        if (template === Templates.RiskRegister) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Risk ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Description',
                orderindex: .02,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            const c1text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Risk Impact',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(c1text);
            const c2text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Risk Response',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(c2text);
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Risk Level',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'High',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Medium',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Low',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            const stask = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Risk Owner',
                orderindex: .06,
                required: false,
                type: SchemaItemType.UserChoice,
                addtotasks: true,
                multiselect: false,
            };
            sitems.push(stask);
            const c3text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Notes',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(c3text);
            return sitems;
        }
        if (template === Templates.ToDoList) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Task Name',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Priority',
                orderindex: .02,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'High',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Medium',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Low',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Status',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Not Started',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'In Progress',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Completed',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'On Hold',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Start Date',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Date
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'End Date',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Date
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            return sitems;
        }
        if (template === Templates.WorkOrder) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Work ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Description',
                orderindex: .02,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Hours',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Rate (Rs.)',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Total Price (Rs.)',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Number,
            });
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Status',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Not Started',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'In Progress',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Completed',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'On Hold',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            const c1text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Notes',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(c1text);
            return sitems;
        }
    }
    getDatasheetTemplate(template) {
        const pks = LetrwingCrypto.getNewKeypair();
        const skh = LetrwingCrypto.generateNewSecretKey();
        const wkyes = {
            shkey: skh,
            priavatekey: pks.privatkey,
            publickey: pks.publickey
        };
        if (template === DatasheetTemplate.ProductionManagment) {
            const citem = {
                "id": "5c4a2672-13c9-4616-a01c-335d687d3a4d",
                "name": "Reorder Urgency",
                "orderindex": 0.001,
                "required": false,
                "type": 6,
                "items": [
                    {
                        "id": "615a16c2-1f85-45a3-bd5c-c472d1c9a608",
                        "name": "High",
                        "type": 0
                    },
                    {
                        "id": "7f400dc4-f3dd-4868-b5c8-a9cf112d8348",
                        "name": "Medium",
                        "type": 0
                    },
                    {
                        "id": "1171eea8-1765-48d8-a2f8-adcbe8ab10c5",
                        "name": "Low",
                        "type": 0
                    }
                ],
                "multiselect": false
            };
            const titem = {
                "id": "706443e1-5097-4fbc-81ed-2cde23436aa7",
                "name": "Comments",
                "orderindex": 0.007,
                "required": false,
                "type": 0,
                "richtext": true
            };
            const titem2 = {
                "id": "d64e0207-e5f1-40e6-9172-37d84aac7466",
                "name": "Description",
                "orderindex": 0.03,
                "required": false,
                "type": 0,
                "richtext": true
            };
            const citem1 = {
                "id": "024f1984-90d4-4b04-bca1-927acc1aeb30",
                "name": "Reorder",
                "orderindex": 0.07,
                "required": false,
                "type": 6,
                "items": [
                    {
                        "id": "abb998fa-bdc2-4fe5-a439-c31ace512c93",
                        "name": "Yes",
                        "type": 0
                    },
                    {
                        "id": "7a635385-de5b-4817-a6c4-c440f6769679",
                        "name": "No",
                        "type": 0
                    }
                ],
                "multiselect": false
            };
            const citem3 = {
                "id": "5a8ff0b6-c4a7-49f7-b539-d5cd7a9fe28b",
                "name": "Order Status",
                "orderindex": 0.02,
                "required": false,
                "type": 6,
                "items": [
                    {
                        "id": "e7554526-e986-44f1-a87f-bb56f167d892",
                        "name": "Started",
                        "type": 0
                    },
                    {
                        "id": "757d7b3f-1b6a-463c-9739-0315a660d67f",
                        "name": "In Progress",
                        "type": 0
                    },
                    {
                        "id": "909a22ea-2308-41dc-a0b8-08fd5e89adff",
                        "name": "Done",
                        "type": 0
                    }
                ],
                "multiselect": false
            };
            const titem4 = {
                "id": "59717906-b9e7-47e0-8803-8771fdb9c777",
                "name": "Notes",
                "orderindex": 0.092,
                "required": false,
                "type": 0,
                "richtext": true
            };
            const citem4 = {
                "id": "f6580309-170b-4e55-babc-996ce502bf25",
                "name": "Status",
                "orderindex": 0.04,
                "required": false,
                "type": 6,
                "items": [
                    {
                        "id": "13e6441d-b4fe-480e-8742-4c4a4144c253",
                        "name": "Not Started",
                        "type": 0
                    },
                    {
                        "id": "9064989e-e844-49e0-b8c4-5e3346cde16b",
                        "name": "In Progress",
                        "type": 0
                    },
                    {
                        "id": "df65c863-c0e9-42a3-bf10-2d90e1766502",
                        "name": "Completed",
                        "type": 0
                    },
                    {
                        "id": "099f853c-1846-4dc8-a781-8176a5cb0597",
                        "name": "On Hold",
                        "type": 0
                    }
                ],
                "multiselect": false
            };
            const ritems = [
                citem,
                titem,
                {
                    "id": "ae611fda-163e-4575-bf22-5724a345e311",
                    "name": "Inventory ID",
                    "orderindex": 0.01,
                    "required": true,
                    "type": 9
                },
                {
                    "id": "250aaebd-552c-4a7d-aee7-e24b7cf6e9f9",
                    "name": "Name",
                    "orderindex": 0.02,
                    "required": true,
                    "type": 9
                },
                titem2,
                {
                    "id": "5dd9a44c-b8a5-4b5b-8928-a1d43a4b7c93",
                    "name": "Unit Price (Rs.)",
                    "orderindex": 0.04,
                    "required": false,
                    "type": 1
                },
                {
                    "id": "942f09ed-f99a-4d25-a17f-027e7530ddf2",
                    "name": "Quantity In Stock",
                    "orderindex": 0.05,
                    "required": false,
                    "type": 1
                },
                {
                    "id": "152661e6-e978-47a5-8586-2d541d32736e",
                    "name": "Inventory Price (Rs.)",
                    "orderindex": 0.06,
                    "required": false,
                    "type": 1
                },
                {
                    "id": "8db793f3-69b2-4058-ad1a-3bc9bc6e89ec",
                    "name": "Reorder Quantity",
                    "orderindex": 0.06,
                    "required": false,
                    "type": 1
                },
                citem1
            ];
            const ret = [
                {
                    "id": "63c598de07489825533e48bd",
                    "viewers": [
                        "everyone"
                    ],
                    "items": ritems,
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Inventory Management ",
                    "numberoffset": 948828,
                    "dateoffset": 339279,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformbox: { items: ritems, rules: [] },
                    webformkeys: wkyes
                },
                {
                    "id": "63c5990707489825533e48be",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "375da12a-fc08-4e23-8f80-a1f1d0760be1",
                            "name": "Order ID",
                            "orderindex": 0.01,
                            "required": true,
                            "type": 9
                        },
                        {
                            "id": "ab9ead0c-2006-454b-93bf-fc08010d3ef7",
                            "name": "Purchase Number",
                            "orderindex": 0.012,
                            "required": true,
                            "type": 9
                        },
                        citem3,
                        {
                            "id": "ff3c8846-563c-4fa3-b3f2-8fcf860770cb",
                            "name": "Customer Name",
                            "orderindex": 0.03,
                            "required": true,
                            "type": 9
                        },
                        {
                            "id": "0b23321a-b187-44f3-b5fc-5a6302a87b1b",
                            "name": "Product List",
                            "orderindex": 0.04,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "12f7fb22-8970-4ce0-b600-ada859370037",
                            "name": "Variation",
                            "orderindex": 0.05,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "fd466dd0-412e-4ffc-9f99-ecbda6fc0752",
                            "name": "Total Product Quantity",
                            "orderindex": 0.06,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "590fffb8-0a11-4ab9-810b-01098b422069",
                            "name": "Starting Inventory",
                            "orderindex": 0.07,
                            "required": true,
                            "type": 1
                        },
                        {
                            "id": "435d27a9-2d3c-410e-b6bd-0364a7a4499d",
                            "name": "Ending Inventory",
                            "orderindex": 0.08,
                            "required": true,
                            "type": 1
                        },
                        {
                            "id": "1b385dee-760d-4feb-acad-20a6f9dacc9e",
                            "name": "Start Date",
                            "orderindex": 0.09,
                            "required": false,
                            "type": 3
                        },
                        {
                            "id": "6a95e92e-7326-4b08-a81b-c12cf3a84dd6",
                            "name": "End Date",
                            "orderindex": 0.091,
                            "required": false,
                            "type": 3
                        },
                        titem4
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Production Plan ",
                    "numberoffset": 444845,
                    "dateoffset": 614005,
                    "metaschemaids": [],
                    "childrensids": [
                        "63c5a53d07489825533e49b8"
                    ],
                    webformkeys: wkyes
                },
                {
                    "id": "63c5994307489825533e48c0",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "1e82b7cc-3496-4a40-bf25-06f4fe09e5b1",
                            "name": "At Risk",
                            "orderindex": 0.01,
                            "required": false,
                            "type": 2
                        },
                        {
                            "id": "b80447f2-5afb-46ce-9bd8-dbd1a6b08f67",
                            "name": "Task Name",
                            "orderindex": 0.02,
                            "required": true,
                            "type": 9
                        },
                        {
                            "id": "9bbe4581-8e3f-4b77-a1a6-37f8e928add9",
                            "name": "Sub Task Name",
                            "orderindex": 0.03,
                            "required": false,
                            "type": 9
                        },
                        citem4,
                        {
                            "id": "bdb24487-8171-46c3-b5e0-58c2a470ad03",
                            "name": "Assigned To",
                            "orderindex": 0.05,
                            "required": false,
                            "type": SchemaItemType.UserChoice,
                            "addtotasks": true,
                            "multiselect": false
                        },
                        {
                            "id": "e84c18e3-f6cf-455c-81d2-f183f16f3551",
                            "name": "Start Date",
                            "orderindex": 0.06,
                            "required": false,
                            "type": 3
                        },
                        {
                            "id": "c8fd588b-2206-4c26-b4ec-e75adb6b61bb",
                            "name": "End Date",
                            "orderindex": 0.07,
                            "required": false,
                            "type": 3
                        },
                        {
                            "id": "785e17c5-7016-471b-a704-7a7e2b761517",
                            "name": "Comments",
                            "orderindex": 0.08,
                            "required": false,
                            "type": 0,
                            "richtext": true
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Project Tracker",
                    "numberoffset": 65748,
                    "dateoffset": 74911,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63c59a8307489825533e48c1",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "f4c7e63e-cdc1-48dc-8fb9-b377eef48229",
                            "name": "Date",
                            "orderindex": 0.5983269455354214,
                            "required": false,
                            "type": 3
                        },
                        {
                            "id": "10181f90-a8fa-41ec-855e-72ce0cf2104b",
                            "name": "Line 1",
                            "orderindex": 0.8147420711158705,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "899b02dc-2ff0-4b75-8ffa-a6733fd58ce4",
                            "name": "Line 2",
                            "orderindex": 0.9708102851256941,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "d06af33d-dfe6-43c7-b51b-4dd59d7054a8",
                            "name": "Line 3",
                            "orderindex": 0.9726354493658849,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "d1ed4138-a013-42c4-a5b2-56f61a94a79b",
                            "name": "Total",
                            "orderindex": 0.9872505380421327,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "d1d1014a-fd38-4747-8f47-2fd57f1c94fb",
                            "name": "Grand Total",
                            "orderindex": 0.9896427851557211,
                            "required": false,
                            "type": 1
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Line Plan",
                    "numberoffset": 618419,
                    "dateoffset": 991355,
                    "metaschemaids": [
                        "63c59c0507489825533e48d9"
                    ],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63c59c0507489825533e48d9",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "e343602b-7e64-4436-a54f-37412534e187",
                            "name": "M/C",
                            "orderindex": 0.9950988908112628,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "cd637c5d-f91a-48bc-948b-50826ba69e7a",
                            "name": "Line No.",
                            "orderindex": 0.9931570600273824,
                            "required": false,
                            "type": 1
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Install M/C",
                    "numberoffset": 925395,
                    "dateoffset": 581064,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63c59e9607489825533e48ea",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "6d288703-61be-445d-bf64-340a63e07280",
                            "name": "Zone",
                            "orderindex": 0.0681151314367372,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "f43c326c-6b9c-4225-96a9-93d3cf87a1a8",
                            "name": "Reference No",
                            "orderindex": 0.7671042706653407,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "183800b5-c6b0-4f2c-9e63-e52e2a5b117a",
                            "name": "Style Code",
                            "orderindex": 0.898113289491191,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "1a2c9ea5-2713-464d-a6a6-3bfa1c98923e",
                            "name": "Comments",
                            "orderindex": 0.9044226826320317,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "757aa223-598c-4b3b-8094-e19da79627ab",
                            "name": "Images",
                            "orderindex": 0.9599087118278555,
                            "required": false,
                            "type": 12
                        },
                        {
                            "id": "6ab5ba7f-130b-4f64-b1eb-0227104a267f",
                            "name": "Fabricator",
                            "orderindex": 0.9687909631898404,
                            "required": false,
                            "type": 6,
                            "items": [
                                {
                                    "id": "e48d71f6-b11a-4fc2-b19c-b73ba3afade8",
                                    "name": "Rishi",
                                    "type": 0
                                },
                                {
                                    "id": "3303d084-2f1f-4acf-9f9f-5444503a1d26",
                                    "name": "Santosh",
                                    "type": 0
                                }
                            ]
                        },
                        {
                            "id": "4b3efa9d-9c66-44d7-a789-84aaea5cc6d4",
                            "name": "Fabric Color",
                            "orderindex": 0.9729180426182298,
                            "required": false,
                            "type": 4
                        },
                        {
                            "id": "83450335-f7b1-4961-9172-4f8382b7b5c2",
                            "name": "Design Concept",
                            "orderindex": 0.992011778301309,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "252d2a25-eecc-4d13-af6b-c969a447ed0a",
                            "name": "Fabric Type",
                            "orderindex": 0.998026482156355,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "3b4e04e4-6a19-4613-8781-aaa11638c6ab",
                            "name": "Print Type",
                            "orderindex": 0.9982520626612484,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "600df134-1b16-4957-ab66-daaafe506ffc",
                            "name": "1st Drop Qty",
                            "orderindex": 0.999839450050036,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "b5c2324d-ba99-457f-8b8f-f3aec2f1752a",
                            "name": "2nd Drop Qty",
                            "orderindex": 0.9999413912348896,
                            "required": false,
                            "type": 0
                        },
                        {
                            "id": "047cf877-caae-4d58-9730-74217a3684bb",
                            "name": "Total Buy Qty",
                            "orderindex": 0.9999778614958312,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "1ca93b2c-1c4e-41ee-b514-9ab7e0d4e276",
                            "name": "RP DATE",
                            "orderindex": 0.9999971893427467,
                            "required": false,
                            "type": 3
                        },
                        {
                            "id": "77e7fd53-cf00-456c-b0b5-41129fed0191",
                            "name": "Price",
                            "orderindex": 0.999998935064899,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "3106011d-4de6-49b4-be9d-a72eee730256",
                            "name": "Vendor NAme",
                            "orderindex": 0.9999998946543781,
                            "required": false,
                            "type": 6,
                            "items": [
                                {
                                    "id": "836b9f30-62a7-405f-9f8c-30800ce88c6a",
                                    "name": "Kriti Creations",
                                    "type": 0
                                },
                                {
                                    "id": "ddd49ce6-ad7a-46a1-be77-8f1e9bf2ccc7",
                                    "name": "Cloth Hub",
                                    "type": 0
                                }
                            ]
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "T&A",
                    "numberoffset": 209551,
                    "dateoffset": 847198,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63c5a53d07489825533e49b8",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "5dd4cf96-22af-4166-9251-af33db347ab8",
                            "name": "Status",
                            "orderindex": 0.6666188925429926,
                            "required": false,
                            "type": 6,
                            "items": [
                                {
                                    "id": "b18d4287-f628-4258-8cae-a58dbccfcf6c",
                                    "name": "Stiching",
                                    "type": 0
                                },
                                {
                                    "id": "8ce086a6-1587-46f5-a65f-db5e4cad3fe4",
                                    "name": "Printing",
                                    "type": 0
                                },
                                {
                                    "id": "5b383d7c-b54c-47f8-8d3c-bfaf05db4d17",
                                    "name": "Finishing",
                                    "type": 0
                                },
                                {
                                    "id": "56fb6879-8e7d-476e-be40-2957b8ee3cb0",
                                    "name": "QC",
                                    "type": 0
                                },
                                {
                                    "id": "b5880938-297e-4e23-8e1c-3faf8ebb4427",
                                    "name": "Shipping",
                                    "type": 0
                                }
                            ]
                        },
                        {
                            "id": "61bf1e60-b7e5-40e9-940a-54d59a895267",
                            "name": "Remarks",
                            "orderindex": 0.7068058614884366,
                            "required": false,
                            "type": 0
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Vendor 1",
                    "numberoffset": 419120,
                    "dateoffset": 357588,
                    "metaschemaids": [],
                    "childrensids": [],
                    "parentschemaid": "63c5990707489825533e48be",
                    webformkeys: wkyes
                },
                {
                    "id": "63c6707428168331ebb7e240",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "6e9f6a8e-06ae-43b0-b1c9-33a88c913ccb",
                            "name": "Item ID",
                            "orderindex": 0.01,
                            "required": true,
                            "type": 9
                        },
                        {
                            "id": "33cc657b-39e9-4e3b-bd84-4fbc833b7831",
                            "name": "Description",
                            "orderindex": 0.02,
                            "required": false,
                            "type": 0,
                            "richtext": true
                        },
                        {
                            "id": "6f574e8c-a04f-4051-8eef-050ecaeaab85",
                            "name": "Quantity",
                            "orderindex": 0.03,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "2abb7662-4e9a-4710-b26a-03ba4465040c",
                            "name": "Unit Price (Rs.)",
                            "orderindex": 0.04,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "7abab40e-7a91-41fd-87a5-73db7e2dab3e",
                            "name": "Total Price (Rs.)",
                            "orderindex": 0.05,
                            "required": false,
                            "type": 1
                        },
                        {
                            "id": "b804e434-ffac-4d6b-aad2-9cde8cc86019",
                            "name": "Status",
                            "orderindex": 0.06,
                            "required": false,
                            "type": 6,
                            "items": [
                                {
                                    "id": "b9232f62-7a0c-4be3-a6a4-4c9b2f33090d",
                                    "name": "Not Started",
                                    "type": 0
                                },
                                {
                                    "id": "a7074260-edc1-4c2c-afad-c6bfe0884def",
                                    "name": "In Progress",
                                    "type": 0
                                },
                                {
                                    "id": "c59b7c5f-53f0-4a56-90ba-983ae41c3a82",
                                    "name": "Completed",
                                    "type": 0
                                },
                                {
                                    "id": "070b10e6-2013-498f-8360-24f2b0d78eff",
                                    "name": "On Hold",
                                    "type": 0
                                }
                            ],
                            "multiselect": false
                        },
                        {
                            "id": "1c343d57-b0f1-44bf-a0b0-6d1545a11aad",
                            "name": "Notes",
                            "orderindex": 0.07,
                            "required": false,
                            "type": 0,
                            "richtext": true
                        },
                        {
                            "id": "2411ebff-cb14-499a-b914-5ccd2b2e0d97",
                            "name": "Delivery date",
                            "orderindex": 0.8580883488212205,
                            "required": false,
                            "type": 3
                        },
                        {
                            "id": "71a48a51-2ef0-43e3-b178-f8fd10def9b1",
                            "name": "Shipping Method",
                            "orderindex": 0.9565245064703035,
                            "required": false,
                            "type": 6,
                            "items": [
                                {
                                    "id": "77726fe8-5ed4-486a-b8f4-ceb94ee8524b",
                                    "name": "Fed Ex",
                                    "type": 0
                                },
                                {
                                    "id": "bde57419-b295-4c29-9957-55ae78e36fb2",
                                    "name": "DHL",
                                    "type": 0
                                }
                            ]
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Purchase Order List",
                    "numberoffset": 49004,
                    "dateoffset": 744418,
                    "metaschemaids": [
                        "63c6717628168331ebb7e24b",
                        "63c671a328168331ebb7e24c"
                    ],
                    "childrensids": [
                        "63c672e928168331ebb7e25e"
                    ],
                    webformkeys: wkyes
                },
                {
                    "id": "63c6717628168331ebb7e24b",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "80e318dc-6738-4e67-9d59-7d3b9e590f85",
                            "name": "Vendor",
                            "orderindex": 0.31250493487901565,
                            "required": false,
                            "type": 0,
                            "richtext": true
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Vendor ",
                    "numberoffset": 553407,
                    "dateoffset": 48760,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63c671a328168331ebb7e24c",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "f090e2de-f8ac-4e09-8560-c49503106dd9",
                            "name": "Ship to",
                            "orderindex": 0.6631205602733332,
                            "required": false,
                            "type": 0
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Ship To ",
                    "numberoffset": 66301,
                    "dateoffset": 869717,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63c672e928168331ebb7e25e",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63c598c207489825533e48bc",
                    "name": "Vendor 1 Purchase Order",
                    "numberoffset": 435091,
                    "dateoffset": 488495,
                    "metaschemaids": [],
                    "childrensids": [],
                    "parentschemaid": "63c6707428168331ebb7e240",
                    webformkeys: wkyes
                }
            ];
            for (const r of ret) {
                r.webformbox = { items: r.items, rules: [] };
            }
            return ret;
        }
        else if (template === DatasheetTemplate.CRM) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Company Name',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Contact Name',
                orderindex: .03,
                required: false,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Contact Position',
                orderindex: .04,
                required: false,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Web Link',
                orderindex: .05,
                required: false,
                type: SchemaItemType.URL
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Date of Last Contact',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Date
            });
            const ctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Next Action',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ctext);
            const citem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Stage of Lead',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Lead',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Marketing qualified lead',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Sales qualified lead',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Opportunity',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Customer',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Evangelist',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Other',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(citem);
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Source of Lead',
                orderindex: .08,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Social Media',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Email Marketing',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Paid Ads',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Referrals',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Events',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'SEO',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Other',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            const cc1text = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Contact Details',
                orderindex: .091,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cc1text);
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .091,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            const ret = [
                {
                    "id": "63c598de07489825533e48bd",
                    "viewers": [
                        "everyone"
                    ],
                    items: sitems,
                    accesskey: '',
                    nonce: '',
                    name: "Leads",
                    authorid: '',
                    updatedby: '',
                    lastupdatetime: 0,
                    "datasheetid": "",
                    "numberoffset": 435091,
                    "dateoffset": 488495,
                    "metaschemaids": [],
                    "childrensids": [],
                    "parentschemaid": "",
                    letrid: '',
                    webformkeys: wkyes
                }
            ];
            return ret;
        }
        if (template === DatasheetTemplate.InventoryManagement) {
            const sitems = [];
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Inventory ID',
                orderindex: .01,
                required: true,
                type: SchemaItemType.FormInput
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Name',
                orderindex: .02,
                required: true,
                type: SchemaItemType.FormInput
            });
            const cctext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Description',
                orderindex: .03,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(cctext);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Unit Price (Rs.)',
                orderindex: .04,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Quantity In Stock',
                orderindex: .05,
                required: false,
                type: SchemaItemType.Number,
            });
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Inventory Price (Rs.)',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Number,
            });
            const cs1item = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Reorder',
                orderindex: .07,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Yes',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'No',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(cs1item);
            const csitem = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Reorder Urgency',
                orderindex: .001,
                required: false,
                type: SchemaItemType.Choice,
                items: [{
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'High',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Medium',
                        type: ChoiceType.Text
                    },
                    {
                        id: LetrwingCrypto.getUUID() + '',
                        name: 'Low',
                        type: ChoiceType.Text
                    }],
                multiselect: false
            };
            sitems.push(csitem);
            sitems.push({
                id: LetrwingCrypto.getUUID() + '',
                name: 'Reorder Quantity',
                orderindex: .06,
                required: false,
                type: SchemaItemType.Number,
            });
            const ccwext = {
                id: LetrwingCrypto.getUUID() + '',
                name: 'Comments',
                orderindex: .007,
                required: false,
                type: SchemaItemType.Text,
                richtext: true
            };
            sitems.push(ccwext);
            const ret = [
                {
                    "id": "63c598de07489825533e48bd",
                    "viewers": [
                        "everyone"
                    ],
                    items: sitems,
                    accesskey: '',
                    nonce: '',
                    name: "Inventory",
                    authorid: '',
                    updatedby: '',
                    lastupdatetime: 0,
                    "datasheetid": "",
                    "numberoffset": 435091,
                    "dateoffset": 488495,
                    "metaschemaids": [],
                    "childrensids": [],
                    "parentschemaid": "",
                    letrid: '',
                    webformkeys: wkyes
                }
            ];
            for (const r of ret) {
                r.webformbox = { items: r.items, rules: [] };
            }
            return ret;
        }
        if (template === DatasheetTemplate.EmployeeManagement) {
            const ret = [
                {
                    "id": "63cd89b719114b3c75ffc0f3",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "00c66ec9-d338-4c68-ac2a-c3dabe6eb1c0",
                            "name": "Name",
                            "orderindex": 0.8669517731160925,
                            "required": true,
                            "type": 9
                        },
                        {
                            "id": "e05d8dfd-ba27-445b-8e02-02b40bad4546",
                            "name": "Employee ID",
                            "orderindex": 0.9849541215410947,
                            "required": true,
                            "type": 1
                        },
                        {
                            "id": "cc6f5f3d-08e1-4d5f-ad60-98d6b8b26a22",
                            "name": "Department",
                            "orderindex": 0.9867532331872169,
                            "required": true,
                            "type": 9
                        },
                        {
                            "id": "0158cb2f-5028-418c-a8cf-a65ce324a66b",
                            "name": "Date of Joining",
                            "orderindex": 0.9960738277762872,
                            "required": false,
                            "type": 3
                        },
                        {
                            "id": "e731f089-c19d-45b4-833a-476b86c4ffcd",
                            "name": "Performance",
                            "orderindex": 2.4976701387623494,
                            "required": false,
                            "type": 12
                        }
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63cd89ad19114b3c75ffc0f2",
                    "name": "Employee",
                    "numberoffset": 941309,
                    "dateoffset": 776681,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63cd89e619114b3c75ffc0f4",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "14212729-9112-4dc1-9f4e-e463de422c7f",
                            "name": "Quality",
                            "orderindex": 0.01,
                            "required": true,
                            "type": 9
                        },
                        ({
                            "id": "8e166e5d-82cb-40cb-89f6-11a300d9a70f",
                            "name": "Characterstics",
                            "orderindex": 0.02,
                            "required": true,
                            "type": 6,
                            "items": [
                                {
                                    "id": "91432c7e-bd5a-432e-b307-ed2e048c0e83",
                                    "name": "Unsatisfactory",
                                    "type": 0
                                },
                                {
                                    "id": "42ade618-f9cd-4213-9ab4-bf501fdf10dd",
                                    "name": "Satisfactory",
                                    "type": 0
                                },
                                {
                                    "id": "53e072dc-e1cf-4e71-a8f8-c63ac54f7ed6",
                                    "name": "Good",
                                    "type": 0
                                },
                                {
                                    "id": "0664a3cc-de76-4e48-8ddb-05c16abfb20f",
                                    "name": "Excellent",
                                    "type": 0
                                }
                            ],
                            "multiselect": false
                        }),
                        ({
                            "id": "26c6f4a1-5b8e-4001-b331-8afae887f977",
                            "name": "Comments",
                            "orderindex": 0.03,
                            "required": false,
                            "type": 0,
                            "richtext": true
                        })
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63cd89ad19114b3c75ffc0f2",
                    "name": "Employee 1 Performance",
                    "numberoffset": 997893,
                    "dateoffset": 338127,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                },
                {
                    "id": "63cd8a0019114b3c75ffc0f5",
                    "viewers": [
                        "everyone"
                    ],
                    "items": [
                        {
                            "id": "14212729-9112-4dc1-9f4e-e463de422c7f",
                            "name": "Quality",
                            "orderindex": 0.01,
                            "required": true,
                            "type": 9
                        },
                        ({
                            "id": "8e166e5d-82cb-40cb-89f6-11a300d9a70f",
                            "name": "Characterstics",
                            "orderindex": 0.02,
                            "required": true,
                            "type": 6,
                            "items": [
                                {
                                    "id": "91432c7e-bd5a-432e-b307-ed2e048c0e83",
                                    "name": "Unsatisfactory",
                                    "type": 0
                                },
                                {
                                    "id": "42ade618-f9cd-4213-9ab4-bf501fdf10dd",
                                    "name": "Satisfactory",
                                    "type": 0
                                },
                                {
                                    "id": "53e072dc-e1cf-4e71-a8f8-c63ac54f7ed6",
                                    "name": "Good",
                                    "type": 0
                                },
                                {
                                    "id": "0664a3cc-de76-4e48-8ddb-05c16abfb20f",
                                    "name": "Excellent",
                                    "type": 0
                                }
                            ],
                            "multiselect": false
                        }),
                        ({
                            "id": "26c6f4a1-5b8e-4001-b331-8afae887f977",
                            "name": "Comments",
                            "orderindex": 0.03,
                            "required": false,
                            "type": 0,
                            "richtext": true
                        })
                    ],
                    "letrid": "",
                    "accesskey": "",
                    "nonce": "",
                    "authorid": "",
                    "lastupdatetime": 0,
                    "updatedby": "",
                    "datasheetid": "63cd89ad19114b3c75ffc0f2",
                    "name": "Employee 2 Performance",
                    "numberoffset": 27864,
                    "dateoffset": 814620,
                    "metaschemaids": [],
                    "childrensids": [],
                    webformkeys: wkyes
                }
            ];
            for (const r of ret) {
                r.webformbox = { items: r.items, rules: [] };
            }
            return ret;
        }
    }
}
export const TemplateStore = new Store();
